import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/right-arrow.svg'
import _imports_1 from '../assets/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f8d08ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "popup-window"
}
const _hoisted_2 = { class: "popup-heading-div" }
const _hoisted_3 = {
  key: 0,
  class: "interfaces-heading"
}
const _hoisted_4 = { class: "message-filter-div" }
const _hoisted_5 = {
  key: 1,
  class: "interfaces-heading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "item-container"
}
const _hoisted_13 = {
  key: 0,
  class: "circle-indicator topic-bg"
}
const _hoisted_14 = {
  key: 1,
  class: "circle-indicator service-bg"
}
const _hoisted_15 = {
  key: 2,
  class: "circle-indicator node-bg"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 4,
  class: "message-heading"
}
const _hoisted_18 = { class: "message-type" }
const _hoisted_19 = {
  key: 1,
  class: "message-container"
}
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dialog-bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exit()))
        }))
      : _createCommentVNode("", true),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.openMessageText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(" Active Messages "),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["message-filter-button", { 'topic-bg': _ctx.interFilter !== 'topic' }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterInterfaces('topic')))
                    }, null, 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["message-filter-button", { 'service-bg': _ctx.interFilter !== 'service' }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterInterfaces('service')))
                    }, null, 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["message-filter-button", { 'node-bg': _ctx.interFilter !== 'node' }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {
              {
                _ctx.filterInterfaces('node');
              }
            })
                    }, null, 2)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "icon-button left-button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.incrementHistory(-1)))
                  }, _hoisted_7),
                  _createElementVNode("button", {
                    class: "icon-button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.incrementHistory()))
                  }, _hoisted_9),
                  _createTextVNode(" " + _toDisplayString(_ctx.openMessageName), 1)
                ])),
            _createElementVNode("button", {
              class: "icon-button red-svg smaller-icon-button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exit()))
            }, _hoisted_11)
          ]),
          (!_ctx.openMessageText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredInterfaces(), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.item.id,
                    class: "item-div"
                  }, [
                    (item.type === 'topic')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Topic "))
                      : _createCommentVNode("", true),
                    (item.type === 'service')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Service "))
                      : _createCommentVNode("", true),
                    (item.type === 'node')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Node "))
                      : _createCommentVNode("", true),
                    (item.type !== 'node')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          href: "#",
                          onClick: ($event: any) => (_ctx.openInterface(item.item, item.type)),
                          class: "message-link message-heading"
                        }, _toDisplayString(item.item.name), 9, _hoisted_16))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.item.name), 1)),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getInterfaceTypeString(item.item, item.type)), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.openMessageText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openMessageText, (field) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: field.id || field.fieldText,
                    class: "message-field-div"
                  }, [
                    (field.id && field.fieldText.split(' ').length > 1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          onClick: ($event: any) => (_ctx.openMessageLink(field.id)),
                          class: "message-link"
                        }, _toDisplayString(field.fieldText.split(' ')[0]), 9, _hoisted_20))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(field.fieldText.split(' ').length > 1
            ? field.fieldText.slice(field.fieldText.indexOf(' '))
            : field.fieldText), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}